import React from "react";
import WorkerSettings from "./WorkerSettings";

export default function SettingsPage() {
    return (
        <div className="animate-fade-in">
            <WorkerSettings />
        </div>
    );
}
